// extracted by mini-css-extract-plugin
export default {"brand":"Emphasis_brand__xJrgH","phrase":"Emphasis_phrase__riMlX"};